var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('router-view'),(!_vm.onMobile)?_c('router-view',{attrs:{"name":"navbar"}}):_vm._e(),_c('router-view',{staticClass:"content",class:{ 'content--mobile': _vm.onMobile },attrs:{"name":"content"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }